import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Dashboard from './consumer_dashboard/Dashboard'
import Layout from './consumer_dashboard/Layout'

const ConsumerDashboardRoot = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/my_dashboard'
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default ConsumerDashboardRoot
